import { useMutation, useModel, useRequest, history, useParams } from "@umijs/max";
import React, {useState, useEffect} from 'react';
import { getHotspotList, getHotspotDashboard, getSmartPushSchemeDetails } from "../services/Hotspot";
import { message } from "antd";

const Hotspot = () => {
    const urlParams = useParams()
    const { smartPushList, setSmartPushList } = useModel('planDetailsState');
    // 状态数据流
    // const [loading, setLoading] = useState(false);
    const [total, setTotal] = useState(0);
    const [hotspotListDataList, setHotspotListDataList] = useState<any>([])
    const [tableParams, setTableParams] = useState<any>({
        page: 1,
        pageSize: 30,
        keyword: ''
    });
    // const [error, setError] = useState<string | null>(null)
    const [hasMore, setHasMore] = useState(true)


    console.log("aa");
    
    // 热点
    const { loading: hotspotListLoading, data: hotspotListData, run: handleHotspotList, cancel: handleHotspotListCancel} =
        useRequest(async (data) => {
            const result = await getHotspotList(data);
            let arr: any = [];
            if (result.status === 0) {
                arr = result.payload.list
            } else {
                arr = []
            }
            
            console.log('日历-d---w3w--232', result, arr)
            return result.payload
        }, {
        manual: true,
    });


    // 智推
    const { loading: hotspotDashboardLoading, data: hotspotDashboardData, run: handleHotspotDashboard, cancel: handleHotspotDashboardCancel} =
        useRequest(async (data) => {
            const result = await getHotspotDashboard(data);
            let arr: any = [];
            if (result.status === 0) {
                arr = result.payload
            } else {
                arr = []
            }
            console.log('日历-d---w3w--232', result, arr)
            return {
                data: arr,
                payload: result.payload
            }
        }, {
        manual: true,
        debounceInterval: 300,
    });

    // 智推详情
    const { loading: smartPushSchemeLoading, data: smartPushSchemeData, run: handleSmartPushSchemeDetails, } =
        useRequest(async (data, isFlag) => {
            let smartPushListArr: any = smartPushList;
            const result = await getSmartPushSchemeDetails(data);
            for(let el of smartPushListArr) {
                if (el.analysisId === data) {
                    Object.assign(el, {
                        isMyScheme: result.payload.isMyScheme,
                    });
                    break;
                }
            }
            const index = smartPushList.findIndex((el: any) => el.analysisId === data);
            // console.log('result :>> ', result, smartPushList, data, index);
            if (result.status === 0) {
                let arr = result.payload.schemeLists.map((item:any) => {
                    let obj = JSON.parse(item.schemeContent);
                    return {
                        ...obj,
                        ...item,
                        hotspotSchemeImageInfoList: item.schemeLists
                    }
                });
                let o = {
                    schemeAnalysisInfo: {
                        ...result.payload.schemeAnalysisInfo,
                        inspiration: result.payload.assistantCurrent ? result.payload.assistantCurrent.topicName : result.payload.marketingCalendar.festivalName,
                    },
                    hotspotAnalysis: JSON.parse(result.payload.schemeAnalysisInfo.hotspotAnalysis),
                    productsName: result.payload.productsName,
                    inspiration: result.payload.assistantCurrent ? result.payload.assistantCurrent.topicName : result.payload.marketingCalendar.festivalName,
                    serviceRequest: result.payload.serviceRequest,
                    brandName: result.payload.brandName,
                    analysisId: data,
                    schemeLists: arr,
                    id:result.payload.id,
                    isMyScheme: result.payload.isMyScheme,
                }
                localStorage.setItem(
                  'marketingCalendar',
                  JSON.stringify({
                    data: o,
                    sources: '智推',
                  }),
                );
                if (!isFlag) {
                    localStorage.setItem(
                        'smartPushList',
                        JSON.stringify({
                          data: smartPushListArr,
                          flagIndex: index,
                        }),
                    );
                    history.push(`/planPageInfo/${urlParams.id}/details`);
                }
            }
            return result.payload
        }, {
        manual: true,
    });



  return {
    hotspotListLoading,
    hotspotListData,
    handleHotspotList,
    hotspotDashboardData,
    hotspotDashboardLoading,
    handleHotspotDashboard,
    smartPushSchemeLoading,
    smartPushSchemeData,
    handleSmartPushSchemeDetails,
    total, setTotal,
    hotspotListDataList, setHotspotListDataList,
    tableParams, setTableParams,
    hasMore, setHasMore
  }
};

export default Hotspot;
